import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import css from './LineItemAdditionalItems.module.css';

const LineItemAdditionalItems = props => {
  const intl = useIntl();
  const { lineItems, transaction } = props;
  const cartAdditionalListings =
    transaction?.attributes?.protectedData?.cartAdditionalListings || {};

  const additionalItems = lineItems.filter(item => item.code.includes('additional-listing'));

  return additionalItems.length > 0 ? (
    <>
      {additionalItems.map((item, i) => {
        const itemId = item.code.replace('line-item/', '');
        const quantity = item.quantity;
        const itemData = cartAdditionalListings[itemId];
        const title = itemData?.title;
        const formattedTotal = formatMoney(intl, item.lineTotal);

        return (
          <div key={`${i}-${item.code}`} className={css.lineItem}>
            <div className={css.itemImage}>
              {itemData?.image && <img src={itemData.image} alt={title} />}
            </div>
            <div className={css.itemInfo}>
              <p className={css.additionalItemTitle}>{title}</p>
              <p className={css.additionalItemQuantity}>x {quantity}</p>
            </div>
            <div className={css.itemValue}>{formattedTotal}</div>
          </div>
        );
      })}
    </>
  ) : null;
};

export default LineItemAdditionalItems;
